module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "konfigurator-pohyb"
    }
  }, [_c('h1', [_vm._v("Jak je " + _vm._s(_vm.mazlicek.jmeno.value) + " aktivní?")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAktivitaValid() && this.tryescape),
      expression: "!isAktivitaValid() && this.tryescape"
    }],
    staticClass: "info-messages-box"
  }, [(!_vm.isAktivitaValid() && this.tryescape) ? _c('div', {
    staticClass: "error-msg"
  }, [_vm._v("Musíte vybrat aktivitu vašeho mazlíčka\n        ")]) : _vm._e()]), _vm._v(" "), (!_vm.mazlicek.jeStene) ? _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-radios",
    class: {
      'has-error': !_vm.isAktivitaValid() && this.tryescape, 'has-success': _vm.isAktivitaValid() && this.tryescape
    }
  }, _vm._l((_vm.pohybItems), function(item) {
    return _c('div', {
      staticClass: "form-type-radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.mazlicek.pohyb.id),
        expression: "mazlicek.pohyb.id"
      }],
      attrs: {
        "type": "radio",
        "id": item.id
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.mazlicek.pohyb.id, item.id)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.mazlicek.pohyb, "id", item.id)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": item.id
      }
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.description.length > 0) ? _c('div', {
      staticClass: "item-desc",
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    }) : _vm._e()])])
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.mazlicek.jeStene) ? _c('info', {
    attrs: {
      "krok": 7
    }
  }) : _c('div', {
    staticClass: "infobox"
  }, [_vm._v("U dospělého psa zde vybíráte, jak je aktivní. U štěňat to pro výpočet Pettime není podstatné. Zvolte “Pokračovat”.")]), _vm._v(" "), (_vm.priceConfirmation.showModal) ? _c('confirmation-modal', {
    attrs: {
      "old-price": _vm.priceConfirmation.oldPrice,
      "new-price": _vm.priceConfirmation.newPrice,
      "confirm-callback": _vm.updatePetAndQuit
    },
    on: {
      "close": function($event) {
        _vm.priceConfirmation.showModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('navigace', {
    attrs: {
      "showPrev": true,
      "onClickPrev": _vm.prev,
      "showNext": true,
      "disableNext": !_vm.valid,
      "onClickNext": _vm.next,
      "onClickSaveAndQuit": _vm.saveAndQuit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71fed695","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/07Pohyb.vue
// module id = 576
// module chunks = 1